module.exports = __webpack_public_path__ + "static/media/profilePhoto.0f86960e.jfif";